<template>
	<div id="loading-bg" :class="classLoading">
		<div class="loading">
			<div class="effect-1 effects"></div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'MsLoading',
	props: {
		classLoading: {
			type: String,
			default: '',
		},
	},
};
</script>
<style scoped>
.loading-bg-push {
	background: rgba(255, 255, 255, 0.45);
}
</style>